





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateShopAddress,UpdateShopAddress,QueryAllShopNameList} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import pcaData from '@/assets/pca.json'
import {getUser} from '@/store/userStore'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class EditShopDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
      province: undefined,
      city: undefined,
      district: undefined,
      defaultRefundAddress: false,
    }
    this.show = false
  }
  private data: any = {
    province: undefined,
    city: undefined,
    district: undefined,
    defaultRefundAddress: false,
  }
  private show = false
  private isEdit = false
  private shopList: Array<any> = []
  private pca = pcaData
  private  userInfo = getUser()


     // 获取省数据
  private get provinceList() {
    return this.pca
  }
    // 获取市数据
  private get cityList() {
    if (!this.data.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  // 获取区数据
  private get districtList() {
    if (!this.data.province || !this.data.city) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    const t2 = t[0].children.filter((e: any) => e.name == this.data.city)
    if (t2.length == 0) {
      return []
    }
    return t2[0].children
  }
  private provinceChange() {
    console.log("dsadsa")
    this.data.city = undefined;
    this.data.district = undefined;
  }


  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = {...this.data,...data}
    this.isEdit = isEdit
    // 加载绑定商品
    const query = {
      startRow: 1,
      limit: 20000
    }
    if(this.userInfo.user.shop){
      this.data.shopId = this.userInfo.user.shop.id
    }
    QueryAllShopNameList(query).then(res=>{
      console.log(res)
      this.shopList = res.list
    })

  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    name: [this.requiredRule],
    mobilePhone: [this.requiredRule],
    shopId: [this.requiredRule],
    address: [this.requiredRule],
  }

  public async save() {

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.data)
        let result = {}
        if(this.isEdit){
          result = await UpdateShopAddress(this.data)
        } else {
          result = await CreateShopAddress(this.data)
        }
        if(result){
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
